import CheckCircle from '@mui/icons-material/CheckCircle'
import RadioButtonUnchecked from '@mui/icons-material/RadioButtonUnchecked'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import { Brand } from '@promoboxx/graphql-gateway-types'
import { makeStyles } from 'tss-react/mui'

import ChildSpacer from '@src/lib/ChildSpacer'

const useStyles = makeStyles()((theme) => ({
  root: {
    'cursor': 'pointer',
    '&, *': {
      boxSizing: 'border-box',
    },
  },
  avatarPaper: {
    overflow: 'hidden',
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(2),
    border: '2px solid transparent',
    aspectRatio: '1',
  },
  avatarImage: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
  avatarSelected: {
    border: `2px solid ${theme.palette.primary.main}`,
  },
  textContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: theme.spacing(2),
  },
}))

interface IndustrySelectableBrandProps {
  brand: Brand
  isSelected: boolean
  onClick: (brand: Brand) => void
}

const IndustrySelectableBrand: React.FC<
  React.PropsWithChildren<IndustrySelectableBrandProps>
> = (props) => {
  const { classes, cx } = useStyles()

  return (
    <div
      className={classes.root}
      onClick={() => {
        props.onClick(props.brand)
      }}
    >
      <Paper
        elevation={props.isSelected ? 6 : undefined}
        className={cx(classes.avatarPaper, {
          [classes.avatarSelected]: props.isSelected,
        })}
      >
        <img
          src={props.brand.logo_url || ''}
          alt={props.brand.name || 'Brand Logo'}
          className={classes.avatarImage}
        />
      </Paper>

      <div className={classes.textContainer}>
        <ChildSpacer>
          {props.isSelected ? (
            <CheckCircle color="action" />
          ) : (
            <RadioButtonUnchecked color="action" />
          )}
          <Typography>{props.brand.name}</Typography>
        </ChildSpacer>
      </div>
    </div>
  )
}

export default IndustrySelectableBrand
